<script>
import ConfirmedPayablesList from "./ConfirmedPayablesList";
import OrderCard from "@/components/Order/Components/Card/Index";

export default {
  components: {
    OrderCard,
    ConfirmedPayablesList
  },

  props: {
    confirmedOrders: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      open: false
    };
  },

  computed: {
    totalOrders: function() {
      return this.confirmedOrders.length;
    }
  }
};
</script>

<template>
  <transition name="down" mode="out-in">
    <div class="orders" v-if="totalOrders">
      <div class="header">
        Limpezas futuras ({{ totalOrders }})
      </div>

      <div class="body">
        <OrderCard
          v-for="order in confirmedOrders.slice(0, 2)"
          :key="order.id"
          :payable="order"
        />
      </div>

      <button class="btn bg-purple" v-if="totalOrders > 2" @click="open = true">
        Ver todos
      </button>

      <ConfirmedPayablesList
        v-if="open"
        @close="open = false"
        :orders="confirmedOrders"
      />
    </div>
  </transition>
</template>

<style scoped>
.orders {
  padding: 12px;
  background-color: #fff;
  border-radius: 2px;
  transition-delay: 500ms;
}

.header {
  margin-bottom: 8px;
  font-weight: 400;
  color: #424242;
}

button {
  width: calc(100% + 24px);
  margin: 16px -12px -12px -12px;
  border-radius: 2px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/components/Payables/ConfirmedPayables.vue